module.exports = __webpack_public_path__ + "img/064dc5034114134cb43eb0ddecbb5fe4.png";